// WYSIWYG print regions, in logical canvas coordinates (400x533 canvas pinned
// exactly over the 600x800 mockup image, i.e. mockup px * 2/3).
// The rectangles match Printful's printable areas for Gildan 5000 Classic Tee:
//   front/back: 12" x 16"  (1800x2400 @150dpi, aspect 0.75)
//   sleeves:     4" x 3.5" (600x525 @150dpi, aspect 1.143)
// Exports are cropped to these regions, so what you see inside the dashed
// guide is exactly what Printful prints, at the same relative size.
export const PRINT_REGIONS = {
  front: { x: 125, y: 136, width: 150, height: 200 },
  back: { x: 125, y: 136, width: 150, height: 200 },
  left: { x: 138, y: 212, width: 136, height: 119 },
  right: { x: 138, y: 212, width: 136, height: 119 },
};

// Crop-export multiplier: front/back -> 1800x2400px (exactly 150 DPI at 12"x16")
export const EXPORT_PIXEL_RATIO = 12;
